import React from "react";
import { BarChart3 } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";

const BenchmarkNarrativeAssessmentViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={BarChart3}
    titleOverride="Shop Summary"
    subtitle="Operational and conversion benchmark interpretation"
    badge="BENCHMARK"
    theme={{
      cardBg: "#fff7ed",
      cardBorder: "#fed7aa",
      heroBg: "#ffedd5",
      heroBorder: "#fdba74",
      badgeBg: "rgba(249, 115, 22, 0.12)",
      badgeBorder: "#ea580c",
      iconColor: "#c2410c",
      dotColor: "#f97316",
    }}
  />
);

export default BenchmarkNarrativeAssessmentViewer;
